import { withServerStoreDataContext as withServerStoreDataContextFactory } from '@grandvisionhq/bloomreach'

export const withServerStoreDataContext = withServerStoreDataContextFactory()
